export const SourceStatuses = {
  VALID: 'VALID',
  INVALID: 'INVALID',
} as const;
